import i18n from 'i18next';

function changeAppLanguage(language) {
i18n.changeLanguage(language)
  .then(() => {
    console.log(`Idioma cambiado a: ${language}`);
  })
  .catch((error) => {
    console.error('Error cambiando el idioma:', error);
  });
}

export default changeAppLanguage;
